import { Either, Left, Right } from 'fp-ts/lib/Either'
import { Response } from 'superagent'

import { log } from '@/log'
import { ApiService } from '@/services/api/service'
import { HOST_ID } from '@/util/appid'
import { ApiClient } from '@spa/services/api/client'

const namespace: string = 'seller_sales_order'

export class SellerSalesOrder extends ApiService {

  async update(id: string, data: object): Promise<Either<Error, Response>> {
    try {
      const response = await ApiClient
          .put(`/api/user-proxy/${this.appId}/seller_sales_order/${id}`)
          .send(data)

      log.debug({ serivce: `${namespace}/update`, response })

      return new Right(response)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  async appendTag(id: string, tags: string[]): Promise<Either<Error, Response>> {
    return this.updateTag(id, 'append', tags)
  }

  async updateTag(id: string, method: 'append', tags: string[]): Promise<Either<Error, Response>> {
    try {
      const response = await ApiClient
        .put(`/api/user-proxy/${this.appId}/seller_sales_order/${id}`)
        .send({
          tags: tags.join(','),
          operation_appid: HOST_ID,
          'update.tag': method,
        })

      log.debug({ service: `${namespace}/${method}`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }
}
